<template>
	<div id="Group">
		<gallery :images="images" :index="index" @close="index = null" />
		<input
			type="file"
			accept=".jpeg, .jpg, .png, .gif"
			class="d-none uploadInput"
			ref="uploadPictures"
			multiple
			@change="handleUploadImage"
		/>
		<div class="row text-center mx--2 align-items-top">
			<div class="col-6 col-sm-4 col-md-2 px-2">
				<div class="total-item-gallery">
					<div class="add-picture-gallery" @click="openInput()">
						<i class="fal fa-file-image"></i>
					</div>
				</div>
			</div>

			<div
				class="col-6 col-sm-4 col-md-2 px-2"
				v-for="(image, imageIndex) in itemsGroup"
				:key="imageIndex"
			>
				<div class="total-item-gallery">
					<div class="hover-shadow cursor">
						<div @click="index = imageIndex">
							<ImageBlock :imagePath="image.contents.url" />
						</div>
						<div class="position-absolute ps-b-0 ps-r-0 m-2">
							<button
								class="btn btn-block btn-primario px-2 py-0"
								@click="removePhotoFromGalery(imageIndex)"
							>
								<i class="fal fa-trash-alt font-14" aria-hidden="true"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import uploadFiles from "@/mixins/uploadFiles";
import ImageBlock from "@/components/blocks/ImageBlock";
import VueGallery from "vue-gallery";
export default {
	name: "Group",
	data() {
		return {
			index: null,
			images: [],
			files: "",
			CDN_URL: null,
			ROOT_API: null,
		};
	},
	props: {
		itemsGroup: {
			type: Array,
			default: [],
		},
	},
	mixins: [uploadFiles],
	components: {
		ImageBlock,
		gallery: VueGallery,
	},
	created() {
		this.populateimages();
	},
	methods: {
		populateimages() {
			this.images = this.itemsGroup.map(
				(image) => `${process.env.CDN_URL}${image.contents.url}`
			);
		},
		removePhotoFromGalery(imageIndex) {
			this.itemsGroup.splice(imageIndex, 1);
			this.images.splice(imageIndex, 1);
		},
		openInput() {
			this.$refs.uploadPictures.click();
		},
		async handleUploadImage() {
			this.files = this.$refs.uploadPictures.files;
			if (this.files) {
				this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);
				const files = await this.uploadImages(this.files);
				if (files) {
					files.forEach((file) => {
						this.itemsGroup.push({
							type: "image",
							contents: {
								url: file,
								width: null,
								height: null,
							},
						});
					});
					setTimeout(() => {
						this.populateimages();
					}, 1000);
				} else {
					alert("Erro ao enviar imagens. Por favor, tente novamente");
				}
				this.$refs.uploadPictures.value = "";
				this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
			}
		},
	},
};
</script>
<style>
.hover-shadow {
	transition: 0.3s;
}

.hover-shadow:hover {
	border-radius: 8px;
	cursor: pointer;
}

.img-galery {
	object-fit: cover;
	max-height: 250px;
	width: 100%;
}
.btn-outline-primario {
	background-color: #fff;
	border: 1px solid rgba(93, 64, 255, 0.5);
	transition: all 300ms;
}
.btn-outline-primario i {
	color: rgba(93, 64, 255, 0.5);
}
.btn-outline-primario:hover {
	background-color: rgba(93, 64, 255, 0.5);
	border: 1px solid rgba(93, 64, 255, 0.5);
}

.total-item-gallery {
	position: relative;
	width: 100%;
	display: inline-block;
}

.btn-outline-primario:hover i {
	color: #fff;
}

@media (max-width: 425px) {
	.next,
	.prev {
		display: none !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/Group.vue